import React from 'react';
import { CATEGORY_META, type SearchCategory } from './types';

const ORDER: SearchCategory[] = [
  'vehicles',
  'real_estate',
  'jobs',
  'marketplace',
  'custom',
];

export default function CategoryCards({
  value,
  onChange,
}: {
  value: SearchCategory;
  onChange: (category: SearchCategory) => void;
}) {
  return (
    <div className="category-cards" role="radiogroup" aria-label="Search category">
      {ORDER.map((id) => {
        const meta = CATEGORY_META[id];
        const selected = value === id;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`category-card${selected ? ' category-card--selected' : ''}`}
            onClick={() => onChange(id)}
          >
            <span className="category-card-icon" aria-hidden>
              {meta.icon}
            </span>
            <span className="category-card-title">{meta.title}</span>
            <span className="category-card-subtitle">{meta.subtitle}</span>
          </button>
        );
      })}
    </div>
  );
}
